import { render } from "./StockLocation.vue?vue&type=template&id=fabb191a"
import script from "./StockLocation.vue?vue&type=script&lang=js"
export * from "./StockLocation.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__